module.exports = __webpack_public_path__ + "static/15-e3c3192252bcf14da0f3b04f72320e58.jpg";